<template>
    <a href="https://vk.com/share.php?url=https://проверить-уникальность.рф&title=Проверка-уникальности.рф. Бесплатная проверка уникальности текста. Все системы в одном месте" class="sidebar-banner">
        <img src="/assets/site/images/sidebar-banner.png">
    </a>
</template>
<script>
    export default {

    }
</script>
